import { AxiosResponse } from 'axios';
import format from 'date-fns/format';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { DATE_FORMAT_MASK, ACTION_FETCH } from './const';
import {
  Items,
  Params,
  FetchParams,
  Providers,
  State,
  Statuses,
  ActivitiesResponse,
} from './types';
import { Dictionary } from '@/types';

const asNumber = (value: number | string): number =>
  (value && (typeof value === 'string' ? parseInt(value, 10) : value)) || 0;

const { ERROR, READY, WAITING } = Statuses;

const CHECK_PARAMS = 'checkParams';
const FETCH_ITEMS = 'fetchItems';
const SET_ITEMS = 'setItems';
const SET_PARAMS = 'setParams';
const SET_STATUS = 'setStatus';
const UPDATE_COUNT = 'updateCount';
const UPDATE_PAGE = 'updatePage';
const UPDATE_LIMIT = 'updateLimit';

const storeModule = ({ $api, $config }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageActivityDayStore extends VuexModule<State, any> {
    // State
    items: Items = [];
    status: Statuses = READY;
    day: number | null = null;
    month: number | null = null;
    year: number | null = null;
    section: string = '';
    subSection: string = '';
    count: number = 0;
    page: number = 0;
    limit: number = 0;

    // Mutations
    @Mutation
    [SET_ITEMS](items: Array<any>) {
      this.items = items.map(
        ({
          age,
          announce,
          code,
          description,
          id,
          image_src,
          name,
          is_locked,
          cop_multi_name,
        }) => ({
          age,
          announce,
          code,
          description,
          id,
          img: image_src,
          name,
          is_locked,
          cop_multi_name,
        }),
      );
    }

    @Mutation
    [SET_PARAMS]({ day, month, year, section, subSection }: FetchParams) {
      this.day = day;
      this.month = month;
      this.year = year;
      this.section = section;
      this.subSection = subSection;
    }

    @Mutation
    [SET_STATUS](status: Statuses) {
      this.status = status;
    }

    @Mutation
    [UPDATE_COUNT](count: number) {
      this.count = count;
    }

    @Mutation
    [UPDATE_PAGE](page: number) {
      this.page = page;
    }

    @Mutation
    [UPDATE_LIMIT](limit: number) {
      this.limit = limit;
    }

    // Actions
    @Action
    async [CHECK_PARAMS](params: Params) {
      const { commit } = this.context;
      try {
        const day = parseInt(params.day, 10);
        const month = parseInt(params.month, 10);
        const year = parseInt(params.year, 10);
        const { section, subSection } = params;
        commit(SET_PARAMS, { day, month, year, section, subSection });
      } catch (e) {
        commit(SET_STATUS, ERROR);
      }
    }

    @Action
    async [ACTION_FETCH](params: Dictionary<string>) {
      const { commit, dispatch } = this.context;
      try {
        commit(SET_STATUS, WAITING);
        const date = (
          params.date || format(new Date(), DATE_FORMAT_MASK)
        ).split('-');
        const day = parseInt(date[2], 10);
        const month = parseInt(date[1], 10);
        const year = parseInt(date[0], 10);
        const { section, subsection } = params;
        const subSection = subsection;
        await dispatch(FETCH_ITEMS, { ...params });
        commit(SET_PARAMS, { day, month, year, section, subSection });
        commit(SET_STATUS, READY);
      } catch (e) {
        commit(SET_STATUS, ERROR);
      }
    }

    @Action
    async [FETCH_ITEMS](p: FetchParams) {
      const params: Dictionary<any> = {
        ...p,
      };
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value === null || value === '') delete params[key];
      });
      if (params.members != null && !Array.isArray(params.members)) {
        params.members = [params.members];
      }

      const {
        data: { data, page, limit, filtered },
      } = await $api.get<ActivitiesResponse>('activities/get', {
        params,
      });

      this.context.commit(SET_ITEMS, data);
      this.context.commit(UPDATE_PAGE, asNumber(page));
      this.context.commit(UPDATE_LIMIT, asNumber(limit));
      this.context.commit(UPDATE_COUNT, asNumber(filtered));
    }
  }

  return PageActivityDayStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/activities/day/store.ts